export default "__VITE_ASSET__7mnYOoAA__"